export enum CandidateFilterType {
  TypeOfJob = 'TypeOfJob',
  Location = 'Location',
  Position = 'Position',
  Facility = 'Facility',
  Department = 'Department',
  Employment = 'Employment',
  JobPositionTitleQueries = 'JobPositionTitleQueries',
}
